<!-- Horizontal Bar Chart: one group-by field (Y-axis) + one formula-driven
     value (X-axis). Single dataset (first of "Datasets" above). -->
<div class="wf-section" *ngIf="active">
  <header class="wf-section-header">
    <h3>{{ host.layoutSectionTitle('axes', 'Bar axes') }}</h3>
  </header>
  <small class="control-hint" *ngIf="host.layoutSectionHint('axes')">{{ host.layoutSectionHint('axes') }}</small>
  <ng-container *ngTemplateOutlet="datasetPicker"></ng-container>

  <div class="control-row">
    <div class="control-group wf-field-drop-zone" *ngIf="host.fieldEnabled('axes', 'groupByField')" (dragover)="host.allowFieldDrop($event)" (drop)="onHorizontalBarGroupFieldDrop($event)">
      <label>{{ host.fieldLabel('axes', 'groupByField', 'Y-axis — group by') }}</label>
      <ng-select
        #ssHbGroup
        class="ss-select"
        [class.is-open]="!!ssHbGroup.isOpen?.()"
        appendTo="body"
        ngClass="ss-dropdown-panel"
        [items]="host.drillDatasetColumns"
        [clearable]="true"
        [searchable]="true"
        [loading]="host.isDrillDatasetColumnsLoading"
        [disabled]="!host.drillDataset"
        [placeholder]="host.drillColumnPlaceholder('dimension')"
        [ngModel]="hbGroupByField || null"
        (ngModelChange)="hbGroupByField = $event || ''"
      ></ng-select>
    </div>
    <div class="control-group" *ngIf="host.fieldEnabled('axes', 'groupByLabel')">
      <label>{{ host.fieldLabel('axes', 'groupByLabel', 'Y-axis display name') }}</label>
      <input type="text" [(ngModel)]="hbGroupByLabel" placeholder="e.g. Type Grouping" />
    </div>
  </div>

  <div class="control-row">
    <div class="control-group" *ngIf="host.fieldEnabled('axes', 'valueLabel')">
      <label>{{ host.fieldLabel('axes', 'valueLabel', 'X-axis value label') }}</label>
      <input type="text" [(ngModel)]="hbValueLabel" placeholder="Value" />
    </div>
    <div class="control-group control-group-full wf-field-drop-zone" *ngIf="host.fieldEnabled('axes', 'valueFormula')" (dragover)="host.allowFieldDrop($event)" (drop)="onHorizontalBarValueFieldDrop($event)">
      <label>{{ host.fieldLabel('axes', 'valueFormula', 'X-axis value formula') }}</label>
      <input type="text" [(ngModel)]="hbValueFormula" placeholder="e.g. [price] + [sum_of_cost_2026]" />
      <small class="control-hint">Used for any group with no override below. Leave blank if every group has one.</small>
    </div>
  </div>

  <!-- Per-group formula overrides: some groups genuinely compute their value
       differently (e.g. a "Base Options" row folding in one adjustment while
       "Additional Options" folds in a different one) rather than one formula
       applying uniformly to every group. A group not listed here falls back
       to the shared formula above. -->
  <div class="control-row">
    <div class="control-group control-group-full">
      <label>Per-group formula overrides (optional)</label>
      <small class="control-hint">
        One formula per group value (matched against the Y-axis field above). A group listed here ignores the shared formula.
      </small>
      <div class="target-reference-row" *ngFor="let entry of hbGroupFormulas">
        <input type="text" [(ngModel)]="entry.group" placeholder="Group value, e.g. Base Options" />
        <input type="text" [(ngModel)]="entry.formula" placeholder="Formula for this group" />
        <button type="button" class="target-reference-remove" (click)="removeHbGroupFormula(entry)">Remove</button>
      </div>
      <button type="button" class="target-reference-add" (click)="addHbGroupFormula()">+ Add group formula</button>
    </div>
  </div>

  <!-- References: when this formula's [Token] isn't a plain dataset column
       but another input's live/recomputed output, type in where it comes
       from so the backend resolves the CURRENT value instead of a stale
       one. Keyed by THIS chart's own componentId. -->
  <ng-container *ngIf="host.formulaReferencesEnabledFor('HORIZONTAL_BAR_CHART')">
    <ng-container *ngTemplateOutlet="referenceList; context: { id: host.componentId }"></ng-container>
  </ng-container>

  <!-- Format accordions (registry `sections`-gated; shell formatControls) -->
  <ng-container [ngTemplateOutlet]="chartFormatAccordion"></ng-container>
</div>
